/* hh-product.js — SP4 Product page JS */

var COPIES = 20;
var TRANSITION = '450ms cubic-bezier(.25,.46,.45,.94)';

/* Height ÷ width of the gallery box — a 3:4 frame.
   This is the native aspect ratio of the product photography: every image on every
   product in the catalogue is exactly 0.75 (verified across all media, Aug 2026). The
   box was 4/5 until then, so `object-fit: cover` was quietly trimming ~6.5% off the top
   and bottom of every hero image. The thumbnails lost the same PERCENTAGE, but at 72px
   wide that is ~3px a side and invisible — which is why only the hero looked cropped.
   .hh-product__thumb-btn (72×96) and the mobile `aspect-ratio: 3/4` must match this. */
var IMG_RATIO = 4 / 3;

function initCarousel() {
  var wrap = document.querySelector('[data-hh-carousel-wrap]');
  var carousel = document.querySelector('[data-hh-carousel]');
  var track = document.querySelector('[data-hh-track]');
  var thumbsEl = document.querySelector('[data-hh-thumbs]');
  if (!wrap || !carousel || !track) return;

  // Collect real slides
  var realSlides = Array.prototype.slice.call(track.querySelectorAll('.hh-product__slide'));
  var N = realSlides.length;
  if (N === 0) return;
  if (N === 1) {
    // Single image: hide nav, no cloning needed
    if (thumbsEl) thumbsEl.style.display = 'none';
    var dots = document.querySelector('[data-hh-dots]');
    if (dots) dots.style.display = 'none';
    return;
  }

  // Clone x20 around center
  var INIT_REAL = N * 10; // start at the 10th copy
  var allSlides = [];
  for (var c = 0; c < COPIES; c++) {
    for (var i = 0; i < N; i++) {
      var clone = realSlides[i].cloneNode(true);
      track.appendChild(clone);
      allSlides.push(clone);
    }
  }
  // Remove original slides (now they're all clones)
  realSlides.forEach(function(s) { s.remove(); });

  // ── Clone the thumbnail strip the same way ────────────────────────────────
  // The strip used to hold exactly N buttons and was positioned by a CLAMPED index
  // (max(0, realIdx - half)), while the carousel below it rode an unbounded `step`
  // across the clone buffer. Two different position models on one control: the
  // carousel wrapped seamlessly, the strip animated all the way back to the top when
  // you stepped from the last image to the first. Giving the strip its own clone
  // buffer lets it ride the SAME `step`, so wrapping is just one more slot of travel.
  // Must happen before the click handlers below are bound, so the clones get them.
  var thumbTrack = document.querySelector('[data-hh-thumb-track]');
  var thumbOverflow = thumbTrack ? thumbTrack.parentElement : null;
  if (thumbTrack) {
    var realThumbs = Array.prototype.slice.call(thumbTrack.querySelectorAll('[data-hh-thumb]'));
    if (realThumbs.length === N) {
      for (var tc = 0; tc < COPIES; tc++) {
        for (var ti = 0; ti < N; ti++) {
          thumbTrack.appendChild(realThumbs[ti].cloneNode(true));
        }
      }
      realThumbs.forEach(function(t) { t.remove(); });
    }
  }

  var step = 0; // offset from INIT_REAL
  var slotPx = 0;
  var gapPx = 0;
  var resizeTimer = null;

  function snap() {
    var dpr = window.devicePixelRatio || 1;
    // Clear the previously-fixed width FIRST so we measure the real available width
    // (the wrap stretches to the column/viewport). Without this, getBoundingClientRect
    // returns the stale fixed width and the carousel never resizes — breaking the peek
    // and feeding a stale image height into the height-sync (→ image overlaps below).
    carousel.style.width = '';
    var w = carousel.getBoundingClientRect().width;
    slotPx = Math.round(w * dpr) / dpr;
    gapPx = window.innerWidth < 768 ? 8 : 0;
    carousel.style.width = slotPx + 'px';
    if (window.innerWidth >= 768) {
      var wrapH = Math.round(slotPx * dpr * IMG_RATIO) / dpr;
      wrap.style.height = wrapH + 'px';
      // Pin the thumbnail strip to the hero image's height. Its CSS is
      // `position:absolute; top:0; bottom:0` inside .hh-product__img-area, which is
      // 100% of the 100vh .hh-product__sticky — so without this the strip was always a
      // full viewport tall and ran past the bottom of the image by whatever the
      // difference happened to be. An explicit height over-constrains the box, which
      // makes CSS drop `bottom` — so this wins without needing !important.
      if (thumbsEl) thumbsEl.style.height = wrapH + 'px';
    } else {
      wrap.style.height = '';
      if (thumbsEl) thumbsEl.style.height = '';
    }
  }

  function setPos(noTransition) {
    var totalIdx = INIT_REAL + step;
    var tx = -totalIdx * (slotPx + gapPx);
    if (noTransition) {
      track.style.transition = 'none';
    } else {
      track.style.transition = 'transform ' + TRANSITION;
    }
    track.style.transform = 'translateX(' + tx + 'px)';
  }

  function updateNav(noTransition) {
    var realIdx = ((INIT_REAL + step) % N + N) % N;
    // Update thumbnails — every clone of index i lights up, so the active border is
    // correct no matter which copy is currently under the viewport.
    var thumbBtns = document.querySelectorAll('[data-hh-thumb]');
    thumbBtns.forEach(function(btn) {
      var i = parseInt(btn.getAttribute('data-hh-thumb'), 10);
      btn.classList.toggle('is-active', i === realIdx);
    });
    // Update dots
    var dotBtns = document.querySelectorAll('[data-hh-dot]');
    dotBtns.forEach(function(btn) {
      var i = parseInt(btn.getAttribute('data-hh-dot'), 10);
      btn.classList.toggle('is-active', i === realIdx);
    });
    // Scroll thumb track
    positionThumbs(noTransition);
  }

  var THUMB_SLOT = 96 + 8; // .hh-product__thumb-btn height + .hh-product__thumb-track gap

  // Which visible slot the active thumbnail sits in. Centred, so the strip shows context
  // on both sides. Top-pinning (`return 0`) was tried side by side and reverted.
  // The loop is unaffected either way — this is a constant offset, so every step still
  // moves exactly one slot in one direction.
  function thumbAnchor(visibleSlots) {
    return Math.floor((visibleSlots - 1) / 2);
  }

  function positionThumbs(noTransition) {
    if (!thumbTrack || !thumbOverflow) return;
    var visible = Math.max(1, Math.floor(thumbOverflow.clientHeight / THUMB_SLOT));
    // Driven by the unbounded `step`, exactly like the carousel — NOT by the wrapped
    // realIdx, which is what made the strip snap back to the top on the last→first step.
    var offset = (INIT_REAL + step) - thumbAnchor(visible);
    thumbTrack.style.transition = noTransition ? 'none' : 'transform ' + TRANSITION;
    thumbTrack.style.transform = 'translateY(' + (-offset * THUMB_SLOT) + 'px)';
  }

  // The clone buffer is finite: COPIES sets starting at the middle one, so `step` has
  // only ~N*10 of travel each way before it runs off the end of the track and the
  // gallery goes blank. Re-base it toward the middle once it drifts far. Shifting by a
  // whole multiple of N puts an identical clone under the viewport, so the correction is
  // invisible — provided the transition is off and it happens while the track is at rest,
  // i.e. immediately before the move that would have overshot.
  var REBASE_AT = N * 4;

  function rebase() {
    if (Math.abs(step) < REBASE_AT) return;
    step -= Math.trunc(step / N) * N;
    setPos(true);
    positionThumbs(true);
    void track.offsetWidth; // flush the instant reposition so the next move animates
  }

  function move(delta) {
    rebase();
    step += delta;
    setPos(false);
    updateNav();
  }

  function goTo(realIdx) {
    // Find shortest-path step from current
    var currentReal = ((INIT_REAL + step) % N + N) % N;
    var delta = realIdx - currentReal;
    if (delta > N / 2) delta -= N;
    if (delta < -N / 2) delta += N;
    move(delta);
  }

  function prevImage() { move(-1); }
  function nextImage() { move(1); }

  // Initial render (no transition)
  snap();
  setPos(true);
  // Enable transition after first paint
  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      track.style.transition = 'transform ' + TRANSITION;
    });
  });
  updateNav(true);

  // Chevron buttons
  var prevBtn = document.querySelector('[data-hh-prev]');
  var nextBtn = document.querySelector('[data-hh-next]');
  if (prevBtn) prevBtn.addEventListener('click', prevImage);
  if (nextBtn) nextBtn.addEventListener('click', nextImage);

  // Thumbnail buttons
  document.querySelectorAll('[data-hh-thumb]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      goTo(parseInt(btn.getAttribute('data-hh-thumb'), 10));
    });
  });

  // Thumb arrows — UP = prevImage, DOWN = nextImage
  var thumbUp = document.querySelector('[data-hh-thumb-up]');
  var thumbDown = document.querySelector('[data-hh-thumb-down]');
  if (thumbUp) thumbUp.addEventListener('click', prevImage);
  if (thumbDown) thumbDown.addEventListener('click', nextImage);

  // Dot buttons
  document.querySelectorAll('[data-hh-dot]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      goTo(parseInt(btn.getAttribute('data-hh-dot'), 10));
    });
  });

  // ── Swipe / drag ──────────────────────────────────────────────────────────
  // The track is transform-driven, so NOTHING scrolls natively — without this block a
  // swipe does nothing and the chevrons/dots are the only way to change image (the bug
  // Mary hit on mobile, Aug 2026). Pointer Events cover touch, pen, and mouse in one path.
  //
  // Axis lock is the critical part: we must not swallow a vertical scroll. We wait for
  // AXIS_LOCK px of travel, decide horizontal vs vertical ONCE, and if it's vertical we
  // bail out entirely for the rest of the gesture and let the page scroll normally.
  // CSS `touch-action: pan-y` on the carousel is the other half — it tells the browser to
  // keep owning vertical panning and hand us the horizontal.
  var AXIS_LOCK = 8;    // px before committing to an axis
  var FLICK_MS = 300;   // a short, fast drag advances even if it didn't travel far
  var FLICK_PX = 24;    // ...provided it moved at least this much
  var THROW = 0.18;     // fraction of a slide that counts as a committed drag
  var dragActive = false, axisLocked = false, isHorizontal = false;
  var dragX0 = 0, dragY0 = 0, dragDx = 0, dragT0 = 0;

  function pitch() { return slotPx + gapPx; }

  function onDragStart(e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    dragActive = true; axisLocked = false; isHorizontal = false;
    dragX0 = e.clientX; dragY0 = e.clientY; dragDx = 0; dragT0 = e.timeStamp;
  }

  function onDragMove(e) {
    if (!dragActive) return;
    var dx = e.clientX - dragX0;
    var dy = e.clientY - dragY0;

    if (!axisLocked) {
      if (Math.abs(dx) < AXIS_LOCK && Math.abs(dy) < AXIS_LOCK) return;
      axisLocked = true;
      isHorizontal = Math.abs(dx) > Math.abs(dy);
      if (!isHorizontal) { dragActive = false; return; }  // vertical → hands off, page scrolls
      track.style.transition = 'none';
      if (carousel.setPointerCapture) {
        try { carousel.setPointerCapture(e.pointerId); } catch (err) {}
      }
    }
    if (!isHorizontal) return;
    dragDx = dx;
    if (e.cancelable) e.preventDefault();
    track.style.transform = 'translateX(' + (-(INIT_REAL + step) * pitch() + dragDx) + 'px)';
  }

  function onDragEnd(e) {
    if (!dragActive) return;
    var committed = isHorizontal;
    dragActive = false; axisLocked = false; isHorizontal = false;
    if (!committed) return;
    var dist = Math.abs(dragDx);
    var flick = (e.timeStamp - dragT0) < FLICK_MS && dist > FLICK_PX;
    var delta = (dist > pitch() * THROW || flick) ? (dragDx < 0 ? 1 : -1) : 0;
    dragDx = 0;
    move(delta);   // snaps forward, or back to where it started
  }

  carousel.addEventListener('pointerdown', onDragStart);
  carousel.addEventListener('pointermove', onDragMove, { passive: false });
  carousel.addEventListener('pointerup', onDragEnd);
  carousel.addEventListener('pointercancel', onDragEnd);
  // Kill the browser's native image-drag ghost, which otherwise hijacks a mouse drag.
  carousel.addEventListener('dragstart', function(e) { e.preventDefault(); });

  // Resize: re-snap, disable transition briefly, re-sync thumb scroll
  _resizeCarousel = function() {
    track.style.transition = 'none';
    snap();
    setPos(true);
    updateNav(true);
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      track.style.transition = 'transform ' + TRANSITION;
    }, 150);
  };
  window.addEventListener('resize', _resizeCarousel);
}

function initHeightSync() {
  var leftCol = document.querySelector('[data-hh-left-col]');
  var rightPanel = document.querySelector('[data-hh-right-panel]');
  var sticky = document.querySelector('[data-hh-sticky]');
  var imgWrap = document.querySelector('[data-hh-carousel-wrap]');
  if (!leftCol || !rightPanel || !sticky) return;
  if (window.innerWidth < 768) return;

  var heightAnimating = false;
  var animRaf = null;

  function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

  // The image only pins while the commerce panel is TALLER than it — i.e. there's
  // panel content to scroll past. The sticky must release exactly when the panel's
  // bottom reaches the image's bottom, then the image scrolls away normally with the
  // page (it must NOT stay pinned over the section below). Two regimes:
  //
  //   panel <= image (shell / short panel): nothing to scroll past. Disable sticky
  //     entirely — image is a normal block, section height = image height. No pin.
  //
  //   panel  > image (filled commerce panel): pin the image. Left col carries a
  //     -100vh margin (CSS) so its layout contribution = height - 100vh. Setting
  //     height = 100vh + (panelH - imageH) makes the section = panelH and gives the
  //     sticky exactly (panelH - imageH) of travel — it releases as the panel ends.
  function computeLayout() {
    var rightH = rightPanel.getBoundingClientRect().height;
    var stickyH = sticky.offsetHeight || window.innerHeight; // 100vh
    var imgH = imgWrap ? imgWrap.offsetHeight : 0;
    var pinned = imgH > 0 && rightH > imgH + 1;
    return { pinned: pinned, targetH: stickyH + (rightH - imgH) };
  }

  function applyUnpinned() {
    // Image taller than panel: normal flow, no sticky, no negative-margin extension.
    sticky.style.position = 'relative';
    sticky.style.height = 'auto';
    leftCol.style.marginBottom = '0';
    leftCol.style.height = 'auto';
  }

  function applyPinned(animated) {
    // Restore CSS-driven sticky (position:sticky, height:100vh, margin-bottom:-100vh)
    sticky.style.position = '';
    sticky.style.height = '';
    leftCol.style.marginBottom = '';
    var targetH = computeLayout().targetH;
    if (!animated) {
      leftCol.style.height = targetH + 'px';
      return;
    }
    if (heightAnimating) {
      cancelAnimationFrame(animRaf);
    }
    var startH = leftCol.getBoundingClientRect().height;
    var delta = targetH - startH;
    if (Math.abs(delta) < 1) { leftCol.style.height = targetH + 'px'; return; }
    var startTime = null;
    var DURATION = 220;
    heightAnimating = true;
    function step(ts) {
      if (!startTime) startTime = ts;
      var elapsed = ts - startTime;
      var progress = Math.min(elapsed / DURATION, 1);
      leftCol.style.height = (startH + delta * easeOutCubic(progress)) + 'px';
      if (progress < 1) {
        animRaf = requestAnimationFrame(step);
      } else {
        heightAnimating = false;
      }
    }
    animRaf = requestAnimationFrame(step);
  }

  function syncHeight(animated) {
    if (computeLayout().pinned) {
      applyPinned(animated);
    } else {
      applyUnpinned();
    }
  }

  // Initial sync (no animation)
  requestAnimationFrame(function() { syncHeight(false); });

  // Watch accordion [hidden] changes
  _heightSyncObserver = new MutationObserver(function() {
    if (!heightAnimating) syncHeight(true);
  });
  document.querySelectorAll('.hh-product__accordion-body').forEach(function(body) {
    _heightSyncObserver.observe(body, { attributes: true, attributeFilter: ['hidden'] });
  });

  // Re-sync on resize
  _resizeHeightSync = function() {
    if (window.innerWidth < 768) {
      // Clear every desktop inline override so mobile renders from pure CSS
      leftCol.style.height = '';
      leftCol.style.marginBottom = '';
      sticky.style.position = '';
      sticky.style.height = '';
    } else {
      syncHeight(false);
    }
  };
  window.addEventListener('resize', _resizeHeightSync);
}

function initCommerceAccordions() {
  var btns = document.querySelectorAll('.hh-product__accordion-btn');
  if (!btns.length) return;

  btns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      var bodyId = btn.getAttribute('aria-controls');
      var body = bodyId ? document.getElementById(bodyId) : null;
      var chevron = btn.querySelector('svg');

      // Close all
      btns.forEach(function(b) {
        b.setAttribute('aria-expanded', 'false');
        b.classList.remove('is-open');
        var bId = b.getAttribute('aria-controls');
        var bBody = bId ? document.getElementById(bId) : null;
        if (bBody) bBody.hidden = true;
        var bChev = b.querySelector('svg');
        if (bChev) bChev.style.transform = '';
      });

      // Toggle current
      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        btn.classList.add('is-open');
        if (body) body.hidden = false;
        if (chevron) chevron.style.transform = 'rotate(180deg)';
        // Scroll fix: if button scrolled above viewport, scroll it back in
        requestAnimationFrame(function() {
          var rect = btn.getBoundingClientRect();
          if (rect.top < 0) {
            window.scrollBy({ top: rect.top - 16, behavior: 'smooth' });
          }
        });
      }
    });
  });
}

function initTabs() {
  var tabs = document.querySelectorAll('[data-tab]');
  if (!tabs.length) return;
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var key = tab.getAttribute('data-tab');
      tabs.forEach(function(t) { t.classList.remove('hh-product__tab--active'); });
      tab.classList.add('hh-product__tab--active');
      document.querySelectorAll('[data-tab-panel]').forEach(function(panel) {
        panel.hidden = panel.getAttribute('data-tab-panel') !== key;
      });
    });
  });
}

function initBundleToggles() {
  document.querySelectorAll('[data-bundle-includes-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var idx = btn.getAttribute('data-bundle-includes-toggle');
      var panel = document.querySelector('[data-bundle-includes="' + idx + '"]');
      if (!panel) return;
      var isHidden = panel.hidden;
      panel.hidden = !isHidden;
      btn.classList.toggle('is-open', isHidden);
    });
  });
}

function initViewMore() {
  var btn = document.querySelector('[data-hh-view-more]');
  if (!btn) return;
  var bundles = document.querySelectorAll('[data-bundle-index]');
  var expanded = false;
  btn.addEventListener('click', function() {
    expanded = !expanded;
    bundles.forEach(function(b) {
      if (parseInt(b.getAttribute('data-bundle-index'), 10) > 0) {
        b.hidden = !expanded;
      }
    });
    var chevron = btn.querySelector('svg');
    if (expanded) {
      btn.childNodes[0].textContent = 'View Less ';
      if (chevron) chevron.style.transform = 'rotate(180deg)';
    } else {
      btn.childNodes[0].textContent = 'View More ';
      if (chevron) chevron.style.transform = '';
    }
  });
}

// Shared cart refresh: re-render the drawer + cart bubble (and open the drawer) from a
// /cart/add.js|change.js response that included `sections`, AND publish the theme's
// pub/sub cartUpdate so the header mobile count, shipping bar, etc. resync. Every HH
// add-to-cart path MUST go through this — the bug where the main ATC silently added
// without updating the UI came from a handler that skipped renderContents + published
// only an unlistened-to DOM event. Call with the parsed JSON from a sections-bearing add.
function hhRefreshCart(state) {
  var drawer = document.querySelector('cart-drawer');
  if (drawer && typeof drawer.renderContents === 'function') {
    drawer.renderContents(state); // re-renders #CartDrawer + #cart-icon-bubble AND opens the drawer
  }
  if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hh-atc', cartData: state });
  }
}

// Standard sections-bearing /cart/add.js body so the response can re-render the drawer + bubble.
function hhAddBody(variantId) {
  return JSON.stringify({
    items: [{ id: variantId, quantity: 1 }],
    sections: ['cart-drawer', 'cart-icon-bubble'],
    sections_url: window.location.pathname
  });
}

function initAtc() {
  var atcBtn = document.querySelector('[data-hh-atc]');
  if (!atcBtn) return;
  var label = atcBtn.querySelector('.hh-btn__label') || atcBtn;
  var originalText = label.textContent;
  atcBtn.addEventListener('click', function() {
    var variantId = parseInt(atcBtn.getAttribute('data-variant-id'), 10);
    if (!variantId) return;
    atcBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: hhAddBody(variantId)
    })
    .then(function(r) { if (!r.ok) throw new Error('cart error'); return r.json(); })
    .then(function(state) {
      label.textContent = 'Added to cart';
      hhRefreshCart(state);
      setTimeout(function() {
        label.textContent = originalText;
        atcBtn.disabled = false;
      }, 1800);
    })
    .catch(function() {
      label.textContent = 'Error — try again';
      setTimeout(function() {
        label.textContent = originalText;
        atcBtn.disabled = false;
      }, 2000);
    });
  });
}

function initBundleAtc() {
  document.querySelectorAll('[data-hh-bundle-atc]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (!variantId) return;
      var originalText = btn.textContent;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: hhAddBody(variantId)
      })
      .then(function(r) {
        if (!r.ok) throw new Error('cart error');
        return r.json();
      })
      .then(function(state) {
        btn.textContent = 'Added to cart';
        hhRefreshCart(state);
        setTimeout(function() {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1800);
      })
      .catch(function() {
        btn.textContent = 'Error — try again';
        setTimeout(function() {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      });
    });
  });
}

function initInciModal() {
  var modal = document.querySelector('[data-hh-inci-modal]');
  if (!modal) return;
  var closeBtn = modal.querySelector('[data-hh-inci-close]');
  var nameEl = modal.querySelector('[data-hh-inci-product]');
  var textEl = modal.querySelector('[data-hh-inci-text]');

  // A set page has several products behind one modal, so its triggers carry their own
  // product name + INCI and we swap the content in on open. Single-product pages
  // pre-render the content and their trigger carries neither, so nothing is swapped.
  function openModal(btn) {
    var name = btn && btn.getAttribute('data-inci-product');
    var text = btn && btn.getAttribute('data-inci-text');
    if (name && nameEl) nameEl.textContent = name;
    if (text && textEl) textEl.textContent = text;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-hh-inci-open]').forEach(function(btn) {
    btn.addEventListener('click', function() { openModal(btn); });
  });

  if (closeBtn) closeBtn.addEventListener('click', closeModal);

  modal.addEventListener('click', function(e) {
    if (e.target === modal) closeModal();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });
}

function initAddonAtc() {
  document.querySelectorAll('[data-hh-addon-atc]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (!variantId) return;
      var originalText = btn.textContent;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: hhAddBody(variantId)
      })
      .then(function(r) {
        if (!r.ok) throw new Error('cart error');
        return r.json();
      })
      .then(function(state) {
        btn.textContent = 'Added';
        hhRefreshCart(state);
        setTimeout(function() {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1800);
      })
      .catch(function() {
        btn.textContent = 'Error';
        setTimeout(function() {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      });
    });
  });
}

var _resizeCarousel = null;
var _resizeHeightSync = null;
var _heightSyncObserver = null;

// Shared one-open-at-a-time accordion: buttons carry data-{key}-acc index,
// bodies carry data-{key}-body matching index.
function initIndexedAccordion(accAttr, bodyAttr) {
  var btns = document.querySelectorAll('[' + accAttr + ']');
  if (!btns.length) return;

  btns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      var idx = btn.getAttribute(accAttr);
      var body = document.querySelector('[' + bodyAttr + '="' + idx + '"]');

      // Close all
      btns.forEach(function(b) {
        b.setAttribute('aria-expanded', 'false');
        var bIdx = b.getAttribute(accAttr);
        var bBody = document.querySelector('[' + bodyAttr + '="' + bIdx + '"]');
        if (bBody) bBody.hidden = true;
      });

      // Toggle current
      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        if (body) body.hidden = false;
      }
    });
  });
}

function initKeyIngredients() {
  initIndexedAccordion('data-ing-acc', 'data-ing-body');
}

function initFaq() {
  initIndexedAccordion('data-faq-acc', 'data-faq-body');
}

var _resizeReviews = null;

function initReviews() {
  var viewport = document.querySelector('[data-hh-reviews-viewport]');
  var track = document.querySelector('[data-hh-reviews-track]');
  var section = document.querySelector('[data-hh-reviews]');
  if (!viewport || !track || !section) return;

  var cards = Array.prototype.slice.call(track.querySelectorAll('.hh-review-card'));
  var N = cards.length;
  if (N === 0) return;

  var REVIEW_GAP = 36;
  var CHAR_LIMIT = 180;

  // ── Expand / collapse: truncate long bodies on init ──
  cards.forEach(function(card) {
    var p = card.querySelector('.hh-review-card__body');
    var btn = card.querySelector('.hh-review-card__expand');
    if (!p || !btn) return;
    var full = p.textContent; // store full text (safe — textContent, not innerHTML)
    card.dataset.fullBody = full;
    if (full.length > CHAR_LIMIT) {
      p.textContent = full.slice(0, CHAR_LIMIT).replace(/\s+$/, '') + '…';
      btn.hidden = false;
      btn.textContent = 'Read more';
      btn.addEventListener('click', function() {
        var expanded = btn.textContent === 'Read less';
        if (expanded) {
          p.textContent = card.dataset.fullBody.slice(0, CHAR_LIMIT).replace(/\s+$/, '') + '…';
          btn.textContent = 'Read more';
        } else {
          p.textContent = card.dataset.fullBody;
          btn.textContent = 'Read less';
        }
      });
    }
  });

  // ── Carousel sizing + step nav ──
  var REVIEWS_VISIBLE = window.innerWidth < 768 ? 1 : 3;
  var reviewSlotPx = 0;
  var step = 0;
  var maxStep = Math.max(0, N - REVIEWS_VISIBLE);
  var resizeTimer = null;

  var leftBtn = section.querySelector('.hh-chev[data-dir="left"]');
  var rightBtn = section.querySelector('.hh-chev[data-dir="right"]');

  function snap() {
    var dpr = window.devicePixelRatio || 1;
    var w = viewport.getBoundingClientRect().width;
    reviewSlotPx = Math.round((w / REVIEWS_VISIBLE) * dpr) / dpr;
    cards.forEach(function(card) {
      card.style.width = 'calc(' + reviewSlotPx + 'px - ' + REVIEW_GAP + 'px)';
    });
  }

  function setPos(noTransition) {
    if (noTransition) {
      track.style.transition = 'none';
    } else {
      track.style.transition = 'transform ' + TRANSITION;
    }
    track.style.transform = 'translateX(' + (-step * reviewSlotPx) + 'px)';
  }

  function updateNav() {
    if (leftBtn) leftBtn.disabled = step <= 0;
    if (rightBtn) rightBtn.disabled = step >= maxStep;
  }

  function go(delta) {
    step = Math.max(0, Math.min(maxStep, step + delta));
    setPos(false);
    updateNav();
  }

  if (leftBtn) leftBtn.addEventListener('click', function() { go(-1); });
  if (rightBtn) rightBtn.addEventListener('click', function() { go(1); });

  snap();
  setPos(true);
  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      track.style.transition = 'transform ' + TRANSITION;
    });
  });
  updateNav();

  _resizeReviews = function() {
    var prevVisible = REVIEWS_VISIBLE;
    REVIEWS_VISIBLE = window.innerWidth < 768 ? 1 : 3;
    maxStep = Math.max(0, N - REVIEWS_VISIBLE);
    if (REVIEWS_VISIBLE !== prevVisible) step = Math.min(step, maxStep);
    track.style.transition = 'none';
    snap();
    setPos(true);
    updateNav();
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      track.style.transition = 'transform ' + TRANSITION;
    }, 150);
  };
  window.addEventListener('resize', _resizeReviews);
}

function initReviewOverlay() {
  var overlay = document.querySelector('[data-hh-review-overlay]');
  if (!overlay) return;

  var form = overlay.querySelector('.hh-review-form');
  var closeBtn = overlay.querySelector('[data-hh-review-close]');
  var starInput = overlay.querySelector('[data-hh-star-input]');
  var starBtns = Array.prototype.slice.call(overlay.querySelectorAll('.hh-star-input__btn'));
  var ratingInput = overlay.querySelector('[data-hh-rating-value]');
  var nameEl = overlay.querySelector('#review-name');
  var emailEl = overlay.querySelector('#review-email');
  var bodyEl = overlay.querySelector('#review-body');
  var submitBtn = overlay.querySelector('[data-hh-review-submit]');

  var rating = 0;
  var closeTimer = null;

  // ── Open / close ──
  function open() {
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function close() {
    overlay.hidden = true;
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-hh-review-open]').forEach(function(btn) {
    btn.addEventListener('click', open);
  });

  // Re-open the overlay after a successful native contact-form post (page reloaded).
  if (overlay.querySelector('[data-hh-review-posted]')) open();

  // Deep-link from the post-purchase review email: /products/<handle>?review=open
  if (/[?&]review=open\b/.test(location.search) || location.hash === '#write-review') open();

  // Name/email handed over by the Vitals review-email bridge (layout/theme.liquid) — one-shot.
  try {
    var prefill = JSON.parse(sessionStorage.getItem('hhReviewPrefill') || 'null');
    sessionStorage.removeItem('hhReviewPrefill');
    if (prefill) {
      if (nameEl && !nameEl.value) nameEl.value = prefill.name || '';
      if (emailEl && !emailEl.value) emailEl.value = prefill.email || '';
    }
  } catch (e) {}
  if (closeBtn) closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) close();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && !overlay.hidden) close();
  });

  // ── Star rating input ──
  function paintStars(n) {
    starBtns.forEach(function(b) {
      var v = parseInt(b.getAttribute('data-star'), 10);
      b.classList.toggle('hh-star-input__btn--filled', v <= n);
    });
  }
  starBtns.forEach(function(b) {
    var v = parseInt(b.getAttribute('data-star'), 10);
    b.addEventListener('mouseenter', function() { paintStars(v); });
    b.addEventListener('click', function() {
      rating = v;
      if (ratingInput) ratingInput.value = String(v);
      paintStars(rating);
      validate();
    });
  });
  if (starInput) {
    starInput.addEventListener('mouseleave', function() { paintStars(rating); });
  }

  // ── Inline validation feedback (so an incomplete submit isn't silently ignored) ──
  var clientError = null;
  function ensureErrorEl() {
    if (clientError) return clientError;
    clientError = document.createElement('p');
    clientError.className = 'hh-review-form__error';
    clientError.setAttribute('role', 'alert');
    clientError.hidden = true;
    if (submitBtn && submitBtn.parentNode) submitBtn.parentNode.insertBefore(clientError, submitBtn);
    return clientError;
  }
  function showClientError() {
    var el = ensureErrorEl();
    el.textContent = rating < 1
      ? 'Please add a star rating.'
      : 'Please fill in your name, email, and review.';
    el.hidden = false;
  }
  function clearClientError() {
    if (clientError) clientError.hidden = true;
  }

  // ── Validation ──
  function validate() {
    var ok = rating > 0
      && nameEl && nameEl.value.trim()
      && emailEl && emailEl.value.trim()
      && bodyEl && bodyEl.value.trim();
    if (submitBtn) submitBtn.setAttribute('aria-disabled', ok ? 'false' : 'true');
    if (ok) clearClientError();
    return !!ok;
  }
  [nameEl, emailEl, bodyEl].forEach(function(el) {
    if (!el) return;
    el.addEventListener('input', validate);
    el.addEventListener('change', validate);
  });

  // ── Submit — worker-backed form fetches the reviews worker; the contact-form fallback POSTs natively ──
  if (form) {
    var workerEndpoint = form.getAttribute('data-endpoint'); // present only on the worker form
    form.addEventListener('submit', function(e) {
      if (ratingInput) ratingInput.value = String(rating);
      if (!validate()) { e.preventDefault(); showClientError(); return; }
      if (!workerEndpoint) return; // contact-form fallback → native POST (page reloads with the thank-you)
      e.preventDefault();
      if (submitBtn) submitBtn.setAttribute('aria-disabled', 'true');
      var hp = form.querySelector('[name="hp"]');
      fetch(workerEndpoint, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          product: form.getAttribute('data-product'),
          rating: rating,
          name: nameEl ? nameEl.value.trim() : '',
          email: emailEl ? emailEl.value.trim() : '',
          body: bodyEl ? bodyEl.value.trim() : '',
          hp: hp ? hp.value : ''
        })
      })
        .then(function(r) { return r.json(); })
        .then(function(d) {
          var fields = form.querySelector('[data-hh-review-fields]');
          var thanks = form.querySelector('[data-hh-review-thankyou]');
          if (d && d.ok) { if (fields) fields.hidden = true; if (thanks) thanks.hidden = false; }
          else { ensureErrorEl(); clientError.textContent = 'Sorry — we couldn’t save your review. Please try again.'; clientError.hidden = false; if (submitBtn) submitBtn.setAttribute('aria-disabled', 'false'); }
        })
        .catch(function() { ensureErrorEl(); clientError.textContent = 'Network error — please try again.'; clientError.hidden = false; if (submitBtn) submitBtn.setAttribute('aria-disabled', 'false'); });
    });
  }

  validate();
}

function formatMoney(cents) {
  var d = (cents || 0) / 100;
  return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2));
}

function initYmal() {
  var el = document.querySelector('[data-hh-ymal]');
  if (!el) return;
  var productId = el.dataset.hhYmal;
  var limit = el.dataset.limit || 5;
  fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + limit)
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var products = data.products;
      if (!products || products.length === 0) return; // keep placeholders
      el.textContent = ''; // clear placeholder cards
      products.forEach(function (p) {
        var cardWrap = document.createElement('div');
        cardWrap.className = 'hh-ymal__card';
        var link = document.createElement('a');
        link.href = p.url;
        link.className = 'hh-card';
        var media = document.createElement('div');
        media.className = 'hh-card__media';
        if (p.featured_image) {
          var img = document.createElement('img');
          img.src = p.featured_image + (p.featured_image.indexOf('?') === -1 ? '?width=600' : '&width=600');
          img.alt = p.title;
          img.className = 'hh-card__img';
          img.loading = 'lazy';
          media.appendChild(img);
        }
        var row = document.createElement('div');
        row.className = 'hh-card__row';
        var meta = document.createElement('div');
        meta.className = 'hh-card__meta';
        var name = document.createElement('div');
        name.className = 'hh-card__name';
        name.textContent = p.title;
        var price = document.createElement('div');
        price.className = 'hh-card__price';
        price.textContent = formatMoney(p.price);
        meta.appendChild(name);
        row.appendChild(meta);
        row.appendChild(price);
        link.appendChild(media);
        link.appendChild(row);
        cardWrap.appendChild(link);
        el.appendChild(cardWrap);
      });
    })
    .catch(function () {}); // silently keep placeholders on error
}

function initProduct() {
  initCarousel();
  initHeightSync();
  initCommerceAccordions();
  initKeyIngredients();
  initFaq();
  initTabs();
  initBundleToggles();
  initViewMore();
  initAtc();
  initBundleAtc();
  initAddonAtc();
  initInciModal();
  initReviews();
  initReviewOverlay();
  initYmal();
}

document.addEventListener('DOMContentLoaded', initProduct);
document.addEventListener('shopify:section:load', function(e) {
  if (e.target.querySelector('[data-hh-product]')) initProduct();
});
document.addEventListener('shopify:section:unload', function(e) {
  if (!e.target.querySelector('[data-hh-product]')) return;
  if (_resizeCarousel) window.removeEventListener('resize', _resizeCarousel);
  if (_resizeHeightSync) window.removeEventListener('resize', _resizeHeightSync);
  if (_resizeReviews) window.removeEventListener('resize', _resizeReviews);
  if (_heightSyncObserver) _heightSyncObserver.disconnect();
  _resizeCarousel = null;
  _resizeHeightSync = null;
  _resizeReviews = null;
  _heightSyncObserver = null;
});
